import PendingAdjustmentDetailsHeader from './PendingAdjustmentDetailsHeader'

export default PendingAdjustmentDetailsHeader
